/**
 * Reusable layout for rich legal pages (Mentions légales / Politique de confidentialité / CGU).
 *
 * Renders a clean, readable typographic shell with a kicker, title, optional
 * updated date and a slotted children area for sections.
 */
import { useTranslation } from "react-i18next";

export default function LegalLayout({
  testId,
  kickerKey,
  titleKey,
  updatedAtKey,
  children,
}) {
  const { t } = useTranslation();
  return (
    <main
      data-testid={testId}
      className="min-h-screen px-6 md:px-12 pt-28 pb-24 bg-slate-50/30"
    >
      <div className="max-w-3xl mx-auto">
        <header className="mb-14">
          <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">
            {t(kickerKey)}
          </p>
          <h1 className="mt-3 font-heading text-3xl md:text-4xl font-bold tracking-tight text-slate-900">
            {t(titleKey)}
          </h1>
          {updatedAtKey && (
            <p className="mt-4 text-sm text-slate-500">{t(updatedAtKey)}</p>
          )}
        </header>

        <article
          className="legal-prose space-y-10 text-[15px] leading-relaxed text-slate-700
            [&_h2]:font-heading [&_h2]:text-xl [&_h2]:font-bold [&_h2]:tracking-tight [&_h2]:text-slate-900 [&_h2]:mt-2 [&_h2]:mb-3
            [&_p]:mb-3
            [&_a]:text-slate-900 [&_a]:underline [&_a]:decoration-slate-300 [&_a]:underline-offset-4 hover:[&_a]:decoration-slate-900
            [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1.5 [&_ul]:my-3
            [&_li]:text-slate-700"
        >
          {children}
        </article>
      </div>
    </main>
  );
}
